import { DEFAULT_LANGUAGE } from '@core/types/i18n'
import type { InitOptions } from 'i18next'

export function createI18nConfig(
  options: Partial<InitOptions> = {}
): InitOptions {
  return {
    fallbackLng: DEFAULT_LANGUAGE,
    load: 'languageOnly',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    ...options,
  }
}
